export default {
    clear: 'Clear',
};
